import { OutlineElement } from '../../base/outline-element/outline-element';
import { CSSResultGroup, html, TemplateResult, nothing } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import componentStyles from './ghs-event-card.css.lit';

import '../ghs-icon/ghs-icon';
import '../ghs-heading/ghs-heading.ts';

/**
 * The Event Card component
 *
 * @element ghs-event-card
 * @slot heading - Contains heading content.
 * @slot date-time - Contains date and time content
 * @slot openings - Contains number of openings content
 * @slot cta - Contains ghs-button (secondary variant) CTA content
 * @slot defaultSlot - Contains the content.
 */
@customElement('ghs-event-card')
export class GhsEventCard extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  @state() hasHeadingSlot = false;
  @state() hasDateTimeSlot = false;
  @state() hasOpeningsSlot = false;
  @state() hasCtaSlot = false;

  firstUpdated(): void {
    super.firstUpdated();
    this.hasHeadingSlot = this.querySelector('[slot="heading"]') !== null;
    this.hasDateTimeSlot = this.querySelector('[slot="date-time"]') !== null;
    this.hasOpeningsSlot = this.querySelector('[slot="openings"]') !== null;
    this.hasCtaSlot = this.querySelector('[slot="cta"]') !== null;
  }
  render(): TemplateResult {
    return html`
      <div class="event-card">
        ${this.hasHeadingSlot
          ? html`<div class="event-card-heading">
              <slot name="heading"></slot>
            </div>`
          : nothing}
        ${this.hasDateTimeSlot
          ? html` <div class="event-card-date-time">
              <ghs-icon name="calendar-v2" size="16px" render-for-site="BH">
              </ghs-icon>
              <slot name="date-time"></slot>
            </div>`
          : nothing}

        <!-- Default slot -->
        <div class="event-card-description">
          <slot></slot>
        </div>

        ${this.hasOpeningsSlot
          ? html`<div class="event-card-openings">
              <ghs-icon name="check" size="20px" site=${this.site}></ghs-icon>
              <slot name="openings"></slot>
            </div>`
          : nothing}
        ${this.hasCtaSlot
          ? html`<div class="event-card-cta">
              <slot name="cta"></slot>
            </div>`
          : nothing}
      </div>
    `;
  }
}
